"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
const react_1 = __importDefault(require("react"));
function useIsMobile(breakpoint) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return false;
    }
    const getInitialState = () => window && window.innerWidth < breakpoint;
    const [isMobile, setIsMobile] = react_1.default.useState(getInitialState());
    react_1.default.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return isMobile;
}
exports.useIsMobile = useIsMobile;
